import './style.css';

import App from './models/App';

const forma = document.createElement('form');
forma.innerHTML = "<input type='button' value='search' /> <input type='text' name='reque'/>";
document.body.appendChild(forma);

const slider = document.createElement('div');
slider.className = 'slider';
document.body.appendChild(slider);

const radioButton = document.createElement('div');
radioButton.className = 'radioButton';
document.body.appendChild(radioButton);

let prevVal;
let currentVal;

function takeValue() {
    const input = forma.elements.reque;
    currentVal = input.value;
    if (!currentVal || prevVal === currentVal) {
        return;
    }
    slider.innerHTML = '';
    const request = new App(currentVal);
    prevVal = currentVal;
    request.start();
}

forma.addEventListener('click', takeValue, false);
